module.exports = __webpack_public_path__ + "media/images/entidades_organizadoras/cineicc-46ca6d2dbcbd76d141391821bab27dd5.svg";